import * as rdd from "react-device-detect"

const { isDesktop, isMobile, getUA: userAgent, isFirefox, isTablet, isMacOs } = rdd
const isDigitsMacApp = !!userAgent.match(/Digits for Mac/)
const isSafari = rdd.isSafari || isDigitsMacApp

export { userAgent, isDigitsMacApp, isSafari, isMobile, isFirefox, isTablet, isMacOs, isDesktop }
